var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"invite-table"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.serverReturn,"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }